import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'

// 隐藏加载画面
const hideLoading = () => {
  const loading = document.getElementById('loading')
  if (loading) {
    loading.classList.add('hidden')
    setTimeout(() => {
      loading.remove()
    }, 500)
  }
}

// 当应用加载完成后隐藏加载画面
window.addEventListener('load', () => {
  setTimeout(hideLoading, 1000)
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)